import { combineReducers } from 'redux';

import { cartReducer } from './cartReducer';
import { navigationReducer } from './navigationReducer';
import { customerInfoReducer } from './customerInfoReducer';
import { frontConfigReducer } from './frontConfigReducer';
import { shippingMethodReducer } from './shippingMethodReducer';
import { paymentStatusReducer } from './paymentStatusReducer';
import { expandedTypeReducer } from './expandedTypeReducer';
import { urlParamsReducer } from './urlParamsReducer';
import { bookingReducer } from './bookingReducer';


export const rootReducer = combineReducers({
  cartReducer: cartReducer,
  navigationReducer: navigationReducer,
  customerInfoReducer: customerInfoReducer,
  frontConfigReducer: frontConfigReducer,
  shippingMethodReducer: shippingMethodReducer,
  paymentStatusReducer: paymentStatusReducer,
  expandedTypeReducer: expandedTypeReducer,
  urlParamsReducer: urlParamsReducer,
  bookingReducer: bookingReducer,
});
